import Flex from '@Components/Bases/Flex';
import { FormDatePicker, FormInput } from '@Components/Form';
import { disabledDatePickerTypingStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput/FormatNumberInput';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { IconButton, InputLabel, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';

type GoalYearProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const GoalYear = ({ isCompletedTh, isCompletedEn }: GoalYearProps) => {
  const currentYear = dayjs().startOf('year');

  return (
    <>
      <Typography
        fontWeight={'bold'}
        mt={2}
        sx={{ textDecoration: 'underline' }}
      >
        ปีเป้าหมาย
      </Typography>

      <Flex alignItems={'baseline'} gap={2} mt={1}>
        <Flex
          flexDirection="row"
          justifyContent={'end'}
          minWidth="350px"
          sx={{ paddingLeft: 6 }}
        >
          <InputLabel required>ปีเป้าหมาย</InputLabel>
          <Tooltip
            placement="top"
            arrow
            title={
              'หากบริษัทบรรลุเป้าหมายความเป็นกลางทางคาร์บอนแล้ว กรุณาระบุปีเป้าหมายล่าสุดที่บรรลุ'
            }
          >
            <IconButton size="small">
              <HelpOutlineOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </Flex>

        <FormDatePicker
          name="target.year"
          sx={{ width: '100%', ...disabledDatePickerTypingStyles }}
          views={['year']}
          format="BBBB"
          minDate={currentYear}
          placeholder="เลือกปีเป้าหมาย"
          slotProps={{
            field: {
              clearable: true,
              disabled: isCompletedTh || isCompletedEn,
            },
            toolbar: { hidden: false },
          }}
          localeText={{ toolbarTitle: 'เลือก ปี' }}
        />
      </Flex>
      <Flex alignItems={'baseline'} gap={2} mt={2}>
        <InputLabel
          sx={{
            textAlign: 'end',
            minWidth: '350px',
            paddingLeft: 6,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          การลดสัดส่วนหรือปริมาณการปล่อยก๊าซเรือนกระจกเทียบกับปีฐาน (ถ้ามี)
        </InputLabel>
        <FormInput
          name="target.gasEmissionPercent"
          label="เปอร์เซ็นต์"
          placeholder="(%)"
          sx={{
            width: '50%',
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              disabled: isCompletedTh || isCompletedEn,
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
                max: 100,
              },
            },
            inputLabel: {
              style: {
                fontSize: 12,
              },
            },
          }}
        />
        <Typography>หรือ</Typography>
        <FormInput
          name="target.gasEmissionQuantity"
          label={
            <Typography>
              ตันคาร์บอนไดออกไซด์เทียบเท่า, tCO<sub>2</sub>e
            </Typography>
          }
          placeholder="โปรดระบุจำนวน"
          sx={{
            width: '100%',
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              disabled: isCompletedTh || isCompletedEn,
              inputComponent: FormatNumberInput as React.ComponentType,
            },
            inputLabel: {
              style: {
                fontSize: 12,
              },
            },
          }}
        />
      </Flex>
    </>
  );
};

export default GoalYear;
